import http from '@/api/common'

export default {
  getUser(username) {
    return http.get(`user/GetUserByName?username=${username}`)
  },
  getUsers(searchOptions) {
    return http.get('user/GetUsers', {
      params: searchOptions
    })
  },
  downloadAllUsers() {
    return http.get('user/GetAllUsers')
  },
  createUser(data) {
    return http.post('user/CreateUser', data)
  },
  updateUser(data) {
    return http.post('user/UpdateUser', data)
  },
  checkEmailExists(id, email) {
    return http.post(`user/EmailExists?userID=${id}&email=${email}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/users.js